import languages from '../languages/languages';
import romanianTranslation from '../translations/romanian';
import Translation from '../translations/Translation';
import Localization from './Localization';

const romanianLocalization: Localization<Translation> = {
  language: languages.romanian,
  translatedStrings: romanianTranslation,
};

export default romanianLocalization;
